define('viewmodels/pages/signUp',[
    'underscore',
    'knockout',
    'widgets/inputs/date/viewmodel',
    'widgets/inputs/password/viewmodel',
    'widgets/inputs/phoneNumber/viewmodel',
    'text!widgets/inputs/date/view.html',
    'text!widgets/inputs/password/view.html',
    'text!widgets/inputs/phoneNumber/view.html'
], function (_, ko) {

    function SignUpViewModel(
        signUpModel,
        navigation,
        formFields,
        settings,
        signUpPage,
        Wizard,
        onRegistration
    ) {
        var self = this;
        var signUpCommand = signUpModel.createCommand(function() {
            onRegistration({ selectedWelcomeOfferId: settings.selectedWelcomeOfferId() });
            navigation.navigate(navigation.ROUTES.GAMES);
        });

        this.welcomeOffer = signUpModel.welcomeOffer;

        this.topBarAction = ko.observable();
        this.topBar = ko.observable();

        function createStep(id, field) {

            var step = signUpPage.findFieldByName('steps').pipe(function(steps) {
                return _.find(steps, function(step) {
                    return step.id === id;
                });
            });

            return {
                id: id,
                field: field,
                label: step.property('label'),
                summaryLabel: step.property('summary_label'),
                smallInfo: step.property('small_info')
            };

        }

        this.wizardModel = new Wizard({
            stepIndicatorText: signUpPage.findFieldByName('step_indicator'),
            summaryTitle: signUpPage.findFieldByName('summary_title'),
            summaryText: signUpPage.findFieldByName('summary_text'),
            summaryCallToActionText: signUpPage.findFieldByName('summary_call_to_action_text'),
            summaryEditActionText: signUpPage.findFieldByName('summary_edit_action_text'),
            hasSummary: true,
            steps: [
                createStep('email', formFields.emailField(signUpModel.email)),
                createStep('casumoName', formFields.casumoNameField(signUpModel.casumoName)),
                createStep('plainTextPassword', formFields.passwordField(signUpModel.plainTextPassword)),
                createStep('name.firstName', formFields.textField(signUpModel.name.firstName)),
                createStep('name.lastName', formFields.textField(signUpModel.name.lastName)),
                createStep('dateOfBirth', formFields.dateField(signUpModel.dateOfBirth)),
                createStep(
                    'primaryAddress.country',
                    formFields.countryField(signUpModel.primaryAddress.country)
                ),
                createStep(
                    'primaryAddress.addressLines.street',
                    formFields.textField(signUpModel.primaryAddress.addressLines.street)
                ),
                createStep(
                    'primaryAddress.addressLines.city',
                    formFields.textField(signUpModel.primaryAddress.addressLines.city)
                ),
                createStep(
                    'primaryAddress.addressLines.zip',
                    formFields.textField(signUpModel.primaryAddress.addressLines.zip)
                ),
                createStep('phoneNumber', formFields.phoneNumberField(signUpModel.phoneNumber)),
                createStep('gender', formFields.genderField(signUpModel.gender))
            ],
            onComplete: function () {
                return signUpCommand.dispatch();
            },
            stepsHook: this.topBar,
            backHook: this.topBarAction
        });

        // Keep the selected country and market in sync
        settings.selectedMarket.subscribeAndExec(function(market) {

            if (
                (!signUpModel.primaryAddress.country() ||
                !market.hasCountryWithCode(signUpModel.primaryAddress.country())) &&
                market.country.code !== '__'
            ) {
                signUpModel.primaryAddress.country(market.country.code);
            }

        });

        signUpModel.primaryAddress.country.subscribe(function(countryCode) {
            settings.selectMarketByCountryCode(countryCode);
        });

        // Focus on the first field, needed when we browse the page then open and close the menu on mobile
        this.onMenuNavigationCompleted = function(routeId) {
            if (routeId === navigation.ROUTES.SIGN_UP) {
                self.wizardModel.step().field.isFocused(true);
            }
        };

    }

    return SignUpViewModel;

});

